exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.round[data-v-3e36bc7c] {\n    display: inline-block;\n    color: #000;\n    justify-content: center;\n    align-items: center;\n    border-radius: 100%;\n    text-decoration: none;\n    text-align: center;\n    padding: 1px 4px 1px 4px;\n    margin-left: 1em;\n    font-size: 1em;\n    min-width: 2em;\n}\n", ""]);

// exports
